import { render, staticRenderFns } from "./CargaMasivaCurso.vue?vue&type=template&id=82b740b4&scoped=true"
import script from "./CargaMasivaCurso.vue?vue&type=script&lang=js"
export * from "./CargaMasivaCurso.vue?vue&type=script&lang=js"
import style0 from "./CargaMasivaCurso.vue?vue&type=style&index=0&id=82b740b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b740b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VDialog,VSpacer})
